'use client';
import { getFlexibleFormFieldMetadata } from './flexibleFormFieldMatching';

export const PROMO_CODE_REQUIRED_ERROR = <p>{'Enter a valid promo code'}</p>;
export type PromoCodeErrorState = 'redeemed' | 'expired' | 'invalid';

export function isPromoCodeFormField(formField: SiteFormField) {
    const { fieldName, displayName, label } = getFlexibleFormFieldMetadata(formField);

    return fieldName === 'promocode' || displayName === 'promocode' || label === 'promocode';
}

export function sanitizePromoCode(value: string) {
    return value.replace(/[^A-Za-z0-9-]/g, '');
}

const VIEW_OTHER_OFFERS_TEXT = 'View other offers.';
const PROMO_CODE_REDEEMED_TEXT = 'The promo code entered has already been redeemed.';
const PROMO_CODE_INVALID_TEXT = 'The promo code entered is invalid. Try re-entering your promo code or continue to';

function getPromoCodeFieldErrorLeadText(errorState: PromoCodeErrorState) {
    return errorState === 'redeemed' ? PROMO_CODE_REDEEMED_TEXT : PROMO_CODE_INVALID_TEXT;
}

// Plain-text twin of getPromoCodeFieldErrorMessage, reported to analytics as the displayed error.
export function getPromoCodeFieldErrorText(errorState: PromoCodeErrorState) {
    return `${getPromoCodeFieldErrorLeadText(errorState)} ${VIEW_OTHER_OFFERS_TEXT}`;
}

export function getPromoCodeFieldErrorMessage(errorState: PromoCodeErrorState, viewOtherOffersUrl: string) {
    return (
        <p>
            {`${getPromoCodeFieldErrorLeadText(errorState)} `}
            <a href={viewOtherOffersUrl} target="_self">
                {VIEW_OTHER_OFFERS_TEXT}
            </a>
        </p>
    );
}

export function getPromoCodeFormErrorMessage(viewOtherOffersUrl: string) {
    return (
        <p>
            {'We’re unable to validate your promo code right now. Try again or continue to '}
            <a href={viewOtherOffersUrl} target="_self">
                {VIEW_OTHER_OFFERS_TEXT}
            </a>
        </p>
    );
}
